export const isDevice = (() => {
  if (typeof navigator === 'undefined')
    return {
      // Handle SSR (server-side rendering)
      android: async () => false,
      blackBerry: async () => false,
      iOS: async () => false,
      opera: async () => false,
      windows: async () => false,
      mobile: async () => false,
      desktop: async () => false,
      any: async () => false,
    };

  const uaData = navigator.userAgentData;
  const ua: string = navigator.userAgent;

  return {
    android: async (): Promise<boolean> => uaData?.platform === 'Android' || /Android/i.test(ua),

    blackBerry: async (): Promise<boolean> => /BlackBerry/i.test(ua),

    iOS: async (): Promise<boolean> => uaData?.platform === 'iOS' || /iPhone|iPad|iPod/i.test(ua),

    opera: async (): Promise<boolean> => /Opera Mini/i.test(ua),

    windows: async (): Promise<boolean> =>
      uaData?.platform === 'Windows' || /IEMobile|WPDesktop/i.test(ua),

    mobile: async (): Promise<boolean> => {
      if (uaData?.getHighEntropyValues) {
        const brands = await uaData.getHighEntropyValues(['platform']);
        return /Android|iOS|Windows/i.test(brands.platform);
      }
      return /Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i.test(ua);
    },

    desktop: async (): Promise<boolean> => {
      if (uaData?.getHighEntropyValues) {
        const brands = await uaData.getHighEntropyValues(['platform']);
        return /Windows|Mac|Linux|Chrome OS/i.test(brands.platform);
      }
      return /Windows NT|Macintosh|Linux|X11/i.test(ua);
    },

    any: async (): Promise<boolean> => {
      return (await isDevice.anyMobile()) || (await isDevice.desktop());
    },
  };
})();
